<template>
  <div class="swiper">
    <swiper refs="mySwiper"
            class="swiper"
            v-if="bannerlists.length > 0"
            :options="enterpriseOption">
      <swiper-slide class="swiper-slide"
                    v-for="item in bannerlists"
                    :key="item.sortseq">
        <img class="absolute-leftTop-center slide-img"
             :src="item.fileUrl"
             alt="图片" />
      </swiper-slide>
      <div class="swiper-button-prev"
           slot="button-prev"
           style="left: 3.125rem !important;"></div>
      <div class="swiper-button-next"
           slot="button-next"
           style="right: 3.125rem !important;"></div>
      <div class="swiper-pagination"
           slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import "../assets/css/swiper-3.4.2.min.css";
import {
  swiper,
  swiperSlide
} from "vue-awesome-swiper";
import api from '../api/api'
export default {
  data () {
    return {
      enterpriseOption: {
        loop: true, //衔接
        autoplay: {
          delay: 3000, //1秒切换一次
          disableOnInteraction: true,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        lazyLoading: false,
        preloadImages: false,
        //设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      list: [{
        id: 0,
        // bgColor: '#7078E3',
        // url: require('../assets/images/banner1.png')
      },
      {
        id: 1,
        // bgColor: '#ED4870',
        // url: require('../assets/images/banner2.png')
      }
      ],
      bannerlists: [],
    };

  },
  components: {
    swiper,
    swiperSlide
  },
  created () {
    this.bannerlist()
  },
  methods: {
    //天使列表
    bannerlist () {
      let parm = {
        FKEY: api.getFKEY(),

      }
      api.bannerlist(parm).then((res) => {
        this.bannerlists = res.data.list

      })

    },
  }
}
</script>

<style scoped>
.swiper {
  position: relative !important;
}
.swiper-slide {
  position: relative;
  width: 100%;
  height: 670px;
}
.slide-img {
  width: 100%;
  height: 100%;
}
.swiper-button-prev {
  width: 120px !important;
  height: 120px !important;
  background-image: url("../assets/images/icon_left.png") !important;
  /* background-repeat: no-repeat, no-repeat, repeat-y;
  background-position: center top, center bottom, center top; */
  background-size: 80px !important;
}
.swiper-button-next {
  width: 120px !important;
  height: 120px !important;
  background-image: url("../assets/images/icon_right.png") !important;
  /* background-repeat: no-repeat, no-repeat, repeat-y;
  background-position: center top, center bottom, center top; */
  background-size: 80px !important;
}
.swiper-button-next:hover {
  background-image: url("../assets/images/icon_right_h.png") !important;
}
.swiper-button-prev:hover {
  background-image: url("../assets/images/icon_left_h.png") !important;
}
.swiper-pagination {
  position: absolute;
  bottom: 90px;
  width: fit-content !important;
  left: 81.5% !important;
}
.swiper-pagination-bullet {
  width: 10px !important;
  height: 10px !important;
}
.swiper-pagination-bullet-active {
  background: #ff0000 !important;
}
</style>
